<div class="user-problems" data-qa="help-selection">
  <div class="registration-title" data-qa="help-title">How can we help you?</div>
  <div class="row registration-sub-title company-type-sub-title" data-qa="help-subtitle-row">
    Please check all that apply to help us customize your onboarding experience
  </div>
  <div class="problem-container" data-qa="problem-options">
    @for (problem of problems(); track $index) {
      <div
        class="type-item"
        [ngClass]="{
          'type-selected': selectedProblems[problem.userProblemId]?.selected
        }"
        (click)="onCompanyBuyerChanged($event, problem.userProblemId)"
        data-qa="problem-option"
      >
        <div class="problem" data-qa="problem-description">
          {{ problem.description || problem.name }}
          <div class="type-item-check" data-qa="problem-checkbox">
            <p-checkbox
              [ngModel]="selectedProblems[problem.userProblemId]?.selected"
              [binary]="true"
              [readonly]="true"
              #checkbox
            ></p-checkbox>
          </div>
        </div>
        @if (
          selectedProblems[problem.userProblemId]?.selected &&
          !problem.description
        ) {
          <textarea
            (click)="$event.stopPropagation()"
            [(ngModel)]="selectedProblems[problem.userProblemId].text"
            (ngModelChange)="textChange()"
            pInputTextarea
            data-qa="problem-description-input"
            placeholder="Tell us how we can help you in your role"
          ></textarea>
        }
      </div>
    }
  </div>
</div>
